import { useUnitsFormatter } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";

export const useLayerWeightFormat = (massScaleFactor: number) => {
  const units = useUnitsFormatter(false);
  const decimalPlaces = massScaleFactor > 1 ? 0 : 2;
  const serialiser = useNumberSerialiser({ decimalPlaces, min: 0 });
  const unitLabel = units(massScaleFactor > 1 ? "small_mass" : "mass");

  return { ...serialiser, unitLabel, decimalPlaces };
};
